import { recordSsoTrace } from './debug-trace'
import { EP_SSO_RESUME_PARAM } from './embed-params'

/** Kept dependency-light on purpose: this module runs in the `index` entry
 * before the app chunk loads, so it must not pull clients or Amplify along. */
let captured: string | undefined

/** Detects an embed's resume hop at boot and strips its code off the URL, so
 * neither the app params nor the flow record's `return_to` ever carry it. */
export const captureSsoResume = (): string | undefined => {
  try {
    const url = new URL(window.location.href)
    const code = url.searchParams.get(EP_SSO_RESUME_PARAM)

    if (!code) return undefined

    url.searchParams.delete(EP_SSO_RESUME_PARAM)

    // Strip first: same-origin by construction, so this cannot fail and leave
    // the code behind to be redeemed again on every reload
    window.history.replaceState(null, '', url.toString())

    captured = code

    recordSsoTrace({
      phase: 'embed-start',
      ok: true,
      detail: 'resume hop captured'
    })

    return code
  } catch {
    recordSsoTrace({
      phase: 'embed-start',
      ok: false,
      detail: 'failed to capture the resume hop'
    })

    // A broken capture must never take the whole journey down with it
    return undefined
  }
}

/** Hands the captured code out exactly once, so a re-render or a duplicated
 * runner invocation can never redeem it twice. */
export const takeCapturedSsoResume = (): string | undefined => {
  const code = captured

  captured = undefined

  return code
}

/** Test-only reset — production code must never rewind the single-use take. */
export const __resetSsoResumeCaptureForTests = (): void => {
  captured = undefined
}
